import { useEffect, useState } from "react";
import { Alert, Box, Snackbar, Stack } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import PatientDatas from "src/modules/medcard/patient-datas";
import ByzMuiButton from "src/components/core-components/mui/buttons/ByzMuiButton";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckIcon from "@mui/icons-material/Check";
//import {medcardService} from "src/api/medcards/medcardService";
//IDOGAN;446031;07022025
function PelodScore() {
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState<
    "error" | "warning" | "info" | "success"
  >("success");

  const showAlert = (
    message: string,
    severity: "error" | "warning" | "info" | "success"
  ) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  useEffect(() => {
    //medcardService.create('data1',5);
    //medcardService.delete('data2',5);
    //medcardService.save('data3',5);
  }, []);

  const handleCreateMedcardData = async () => {
    try {
      //const response = medcardService.create('data',5);
      const response = "Medcard Eklendi";
      console.log("Create API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Create API Hatası:", error);
      showAlert("Medcard eklenirken hata oluştu!", "error");
    }
  };

  const handleSaveMedcard = async () => {
    try {
      //const response = medcardService.save('data',5);
      const response = "Medcard Kaydedildi";
      console.log("Save API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Hata:", error);
      showAlert("Medcard kaydedilirken hata oluştu!", "error");
    }
  };

  const handleDeleteMedcard = async () => {
    try {
      //const response = medcardService.delete('data',5);
      const response = "Medcard Silindi";
      console.log("Delete API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Hata:", error);
      showAlert("Medcard silinirken hata oluştu!", "error");
    }
  };

  return (
    <>
      <Stack
        sx={{ padding: "5px", marginBottom: "20px" }}
        mt={5}
        direction="row"
        spacing={2}
      >
        <ByzMuiButton
          variant="contained"
          color="primary"
          onClick={handleSaveMedcard}
        >
          <CheckIcon />
          <ByzMuiTypography ml={0.5} fontSize={13}>
            Kaydet
          </ByzMuiTypography>
        </ByzMuiButton>

        <ByzMuiButton
          variant="contained"
          color="primary"
          onClick={handleDeleteMedcard}
        >
          <DeleteIcon />
          <ByzMuiTypography ml={0.5} fontSize={13}>
            Sil
          </ByzMuiTypography>
        </ByzMuiButton>
        <ByzMuiButton
          variant="contained"
          color="primary"
          onClick={handleCreateMedcardData}
        >
          <AddIcon />
          <ByzMuiTypography ml={0.5} fontSize={13}>
            Ekle
          </ByzMuiTypography>
        </ByzMuiButton>
      </Stack>

      <PatientDatas />
      <Box sx={{ padding: "20px", width: "100%" }}>
        <Grid container spacing={2}>
          <Grid md={6} xs={6} container direction={"column"} spacing={3}>
            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography>Pelod Skor</ByzMuiTypography>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{
                  borderBottom: "1px solid #E0E0E0",
                  paddingRight: "10px",
                  display: "flex",
                }}
              >
                <ByzMuiTypography>Tarih-Saat</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiDateTimePicker
                  sx={{ width: "100%", maxWidth: "300px" }}
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography>Kayıt Yapan Kullanıcı</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiTextField
                  sx={{ width: "300px" }}
                  color="info"
                  disabled
                  label="Kayıt Yapan Kullanıcı"
                  variant="outlined"
                />
              </Grid>
            </Grid>

            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography>Kardiyovasküler</ByzMuiTypography>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>Nabız(Atım/dk)</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Gebelik Durumu"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>
                  Sistolik Kan Basıncı (mm/Hg)
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Sistolik Kan Basıncı (mm/Hg)"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography>Kardiyovasküler Skoru</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <ByzMuiTextField
                  sx={{ width: "300px" }}
                  color="info"
                  disabled
                  label="5"
                  variant="outlined"
                />
              </Grid>
            </Grid>

            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography>Akciğer</ByzMuiTypography>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>PO2 / FIO2</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="PO2 / FIO2"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>PaCO2</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="PaCO2"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>Mekanik Havalandırma</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Mekanik Havalandırma"
                      variant="filled"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography>Akciğer Skoru</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <ByzMuiTextField
                  sx={{ width: "300px" }}
                  color="info"
                  disabled
                  label="5"
                  variant="outlined"
                />
              </Grid>
            </Grid>

            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography>Nörolojik</ByzMuiTypography>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{
                  borderBottom: "1px solid #E0E0E0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Stack direction="row" spacing={2}>
                  <ByzMuiTypography>Glasgow Skoru</ByzMuiTypography>
                  <ByzMuiTypography>|</ByzMuiTypography>
                  <ByzMuiTypography>Puanı</ByzMuiTypography>
                </Stack>
              </Grid>

              <Grid
                md={6}
                xs={6}
                sx={{ justifyContent: "space-between", alignItems: "center" }}
              >
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{ width: "100%", maxWidth: "300px" }}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField
                        {...params}
                        label="Glasgow Skoru"
                        variant="outlined"
                      />
                    )}
                    options={[]}
                    sx={{ flex: 1, width: "140px" }}
                    color="info"
                    label="Seçiniz"
                    placeholder="Seçiniz"
                  />
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField
                        {...params}
                        label="Puanı"
                        variant="outlined"
                      />
                    )}
                    options={[]}
                    sx={{ flex: 1, width: "140px" }}
                    color="info"
                    label="Seçiniz"
                    placeholder="Seçiniz"
                  />
                </Stack>
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>Pupil Reaksiyonları</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Pupil Reaksiyonları"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography>Nörolojik Skoru</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <ByzMuiTextField
                  sx={{ width: "300px" }}
                  color="info"
                  disabled
                  label="5"
                  variant="outlined"
                />
              </Grid>
            </Grid>

            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography>Hematolojik</ByzMuiTypography>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>WBC(10^9/L)</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="WBC(10^9/L)"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>Trombositler</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Trombositler"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography>Hematolojik Skoru</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <ByzMuiTextField
                  sx={{ width: "300px" }}
                  color="info"
                  disabled
                  label="5"
                  variant="outlined"
                />
              </Grid>
            </Grid>

            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography>Hepatik</ByzMuiTypography>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>SGOT</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="SGOT"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>Protrombin Süresi Veya INR</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Protrombin Süresi Veya INR"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography>Hepatik Skoru</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <ByzMuiTextField
                  sx={{ width: "300px" }}
                  color="info"
                  disabled
                  label="5"
                  variant="outlined"
                />
              </Grid>
            </Grid>

            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography>Böbrek</ByzMuiTypography>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography>Kreatinin</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Kreatinin"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography>Böbrek Skoru</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <ByzMuiTextField
                  sx={{ width: "300px" }}
                  color="info"
                  disabled
                  label="5"
                  variant="outlined"
                />
              </Grid>
            </Grid>

            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography>Diğer</ByzMuiTypography>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography>Skor</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <ByzMuiTextField
                  sx={{ width: "300px" }}
                  color="info"
                  disabled
                  label="Skor"
                  variant="outlined"
                />
              </Grid>
            </Grid>
            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography>Öngörülen Ölüm Oranı</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <ByzMuiTextField
                  sx={{ width: "300px" }}
                  color="info"
                  disabled
                  label="Skor"
                  variant="outlined"
                />
              </Grid>
            </Grid>
            <Snackbar
              open={alertOpen}
              autoHideDuration={5000}
              onClose={() => setAlertOpen(false)}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <Alert
                onClose={() => setAlertOpen(false)}
                severity={alertSeverity}
                sx={{ width: "100%" }}
              >
                {alertMessage}
              </Alert>
            </Snackbar>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default PelodScore;
